export const aboutAcf = [
    "intro-title",
    "intro-description",
    "wcu-title",
    "wcu-feature-1-title",
    "wcu-feature-1-description",
    "wcu-feature-2-title",
    "wcu-feature-2-description",
    "wcu-feature-3-title",
    "wcu-feature-3-description",
    "wcu-feature-4-title",
    "wcu-feature-4-description",
];

export const contactFormAcf = [
    'contact-form-title',
    'contact-form-description',
    'contact-form-call-whatsapp',
    'contact-form-email-us',
    'contact-form-working-hours-working-days',
    'contact-form-working-hours-working-saturday',
    'contact-form-working-hours-working-sunday',
]



// WEBPACK FOOTER //
// ./src/constants/acf.js